import { render, staticRenderFns } from "./BackupTableState.vue?vue&type=template&id=70ef2b43&scoped=true&"
import script from "./BackupTableState.vue?vue&type=script&lang=js&"
export * from "./BackupTableState.vue?vue&type=script&lang=js&"
import style0 from "./BackupTableState.vue?vue&type=style&index=0&id=70ef2b43&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ef2b43",
  null
  
)

export default component.exports